/**
 * @example
 * pick({ a: 1, b: 2, c: 3 }, ['a', 'c']) => { a: 1, c: 3 }
 */
export var pick = function pick(obj, keys) {
  return keys.reduce(function (acc, k) {
    if (k in obj) {
      acc[k] = obj[k];
    }
    return acc;
  }, {});
};